import luSaasTable from "./lu-saas-table";
luSaasTable.install = function(Vue) {
  Vue.component(luSaasTable.name, luSaasTable);
};

export default luSaasTable;
